export default "__VITE_ASSET__DKqM1MMQ__"